var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.132,
    cy: 13.173,
    rx: 10.316,
    ry: 11.423
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.514 40.38c0-6.046-11.27-12.071-21.382-12.071-10.112 0-21.382 6.025-21.382 12.07 0 2.535 9.5 4.561 21.382 4.561 11.883 0 21.382-2.026 21.382-4.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.cf294dd2c1b2c09db1c36fb3ecf701d9.svg";
export { ForwardRef as ReactComponent };